// Function to fetch the rate based on selected Organisme
export const fetchOrgaismeRate = async (organismeName) => {
    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;

    try {
        const response = await fetch(`${apiUrl}/api/organisme/rate?title=${encodeURIComponent(organismeName)}`, {
            method: 'GET', // Using GET to retrieve the data
            headers: {
                'Authorization': `Bearer ${token}`, // Attach the token for authentication
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch rate');
        }

        const data = await response.json(); // Parse the JSON response
        return data.tauxCom; // Return the rate (tauxCom)
    } catch (error) {
        console.error('Error fetching rate:', error);
        throw new Error('Failed to fetch rate');
    }
};
